import { Cancel, Check } from '@mui/icons-material';
import { Autocomplete, Box, Button, IconButton, LinearProgress, Tab, Tabs, TextField, Typography } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { userInfo } from '../../../shared/utils';
import { baseUrl } from '../../../state';
import notificationError from '../../../shared/notificationError';
import { useDispatch } from 'react-redux';
import moment from 'moment-timezone';
import notificationSuccess from '../../../shared/notificationSuccess';
import { Dropzone } from '@dropzone-ui/react';
import Webcam from 'react-webcam';
import { createDrivingSession } from '../account.api';

const videoConstraints = {
    width: '100%',
    height: 720,
    facingMode: 'user'
};

const uploadTypeOption = [
    {
        name: 'Take Photo',
        value: 0
    },
    {
        name: 'Upload From Device',
        value: 1
    }
];

export default function Mileage(props: { onClose: any; mileageType?: 'Start' | 'End' | null }) {
    const dispatch: any = useDispatch();
    const webcamRef = useRef<any>(null);

    const [uploadType, setUploadType] = useState<number>(0);

    const [timeOffsetSelected, setTimeOffsetSelected] = useState<number>(0);
    const [filesQueue, setFilesQueue] = useState<any>([]);
    const [isUploading, setIsUploading] = useState(false);

    const [isTakePhoto, setIsTakePhoto] = useState(true);
    const [image, setImage] = useState<string | null>(null);

    const [imageUrl, setImageUrl] = useState<string | null>(null);

    const [miles, setMiles] = useState(0);

    const [links, setLinks] = useState<string[]>(['']);

    useEffect(() => {
        setFilesQueue([]);
    }, []);

    useEffect(() => {
        if (!isUploading && filesQueue.length > 0) {
            setIsUploading(true);
            uploading();
        }
    }, [filesQueue]);

    const onChangeImage = async (filesLocal: any) => {
        if (filesLocal.length > 0) {
            setFilesQueue([
                ...filesQueue,
                ...Array.from(filesLocal).map((file: any) => {
                    return {
                        name: file.name,
                        uploadProgress: 0,
                        file: file.file
                    };
                })
            ]);
        }
    };

    const uploading = async () => {
        let filesLocal: any = filesQueue;
        let filesToUpload: any = filesLocal.filter((file: any) => file.uploadProgress === 0);
        if (filesToUpload.length > 0) {
            for (const i in filesToUpload) {
                try {
                    let data = new FormData();
                    data.append('token', userInfo().token);
                    data.append('file', filesToUpload[i].file);
                    await axios
                        .post(`${baseUrl}/newapi/Account/UploadDrivingSessionAttachment`, data, {
                            onUploadProgress: (progressEvent) => {
                                var percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1));
                                filesLocal = filesLocal.map((f: any) => {
                                    if (f.name === filesToUpload[i].name) {
                                        return {
                                            ...f,
                                            uploadProgress: percentCompleted
                                        };
                                    }
                                    return f;
                                });
                                setFilesQueue(filesLocal);
                            }
                        })
                        .then((response) => {
                            if (response.status === 200) {
                                let link = response.data.data.filePath;
                                setImageUrl(link);
                                notificationSuccess('Uploaded successfully');
                            }
                        });
                } catch (error: any) {
                    console.log(error);
                    notificationError(error.response);
                }
            }
        }
        setIsUploading(false);
       
        // props.onClose();
    };

    const localOffset = new Date().getTimezoneOffset();

    console.log('filesQueue', filesQueue);

    const onSendMileage = async () => {
        dispatch(
            createDrivingSession({
                token: userInfo().token,
                drivingSessions: [
                    {
                        miles: miles,
                        dateTime: moment().format('YYYY-MM-DDTHH:mm:ss'),
                        timeOffset: new Date().getTimezoneOffset(),
                        attachment: imageUrl || ''
                    }
                ]
            })
        )
            .unwrap()
            .then((response: any) => {
                if (response.status === 200) {
                    if (response.data.status) {
                        notificationSuccess(`${props.mileageType} mileage recorded successfully`);
                        if (props.mileageType === 'Start') {
                            window.localStorage.setItem('mileagePopup', JSON.stringify(0));
                            window.localStorage.setItem('drivingSession', JSON.stringify('started'));
                        } else if (props.mileageType === 'End') {
                            window.localStorage.setItem('drivingSession', JSON.stringify('ended'));
                        }
                        props.onClose();
                    } else {
                        notificationError(response.data);
                    }
                } else {
                    notificationError(response.data);
                }
            });
    };

    const capture = useCallback(() => {
        const imageSrc = webcamRef.current.getScreenshot();
        setImage(imageSrc);
        console.log(imageSrc);
    }, [webcamRef]);

    const onUpload = () => {
        if (image) {
            let blob = null;
            let fileName = '';
            fetch(image)
                .then((res) => res.blob())
                .then((b) => {
                    blob = b;
                    fileName = `photo_${moment().format('YYYYMMDD_HHmmss')}.jpeg`;
                    setFilesQueue([
                        ...filesQueue,
                        {
                            name: fileName,
                            uploadProgress: 0,
                            file: new File([blob], fileName, { type: 'image/jpeg' })
                        }
                    ]);
                });
        }
    }

    return (
        <Box>
            <>
                <TextField
                    label={`${props.mileageType} Mileage`}
                    value={miles}
                    InputLabelProps={{ shrink: true }}
                    // InputProps={{ readOnly: true }}
                    onChange={(e) => setMiles(Number(e.target.value))}
                    type="number"
                />
                <br />
                {/* <Box display={'flex'} gap={2}>
                    <Button fullWidth sx={{ marginTop: 1 }} variant="contained" onClick={() => setIsTakePhoto(true)}>
                        Take Photo
                    </Button>
                    <Button fullWidth sx={{ marginTop: 1 }} variant="contained" onClick={() => setIsTakePhoto(false)}>
                        Upload From Device
                    </Button>
                </Box> */}
                <Box>
                    <Tabs variant={'standard'} value={uploadType} onChange={(e, value) => setUploadType(value)}>
                        {uploadTypeOption.map((type, statusIndex) => (
                            <Tab key={statusIndex} label={type.name} value={type.value} sx={{ paddingY: 0 }} />
                        ))}
                    </Tabs>
                </Box>
                <br />
                {uploadType === 0 && (
                    <>
                        {image ? (
                            <>
                                <img src={image} alt="Captured" style={{ width: '100%' }} />
                                <Box display={'flex'} gap={2}>
                                    <Button fullWidth sx={{ marginTop: 1 }} variant="contained" onClick={() => setImage(null)}>
                                        Retake Photo
                                    </Button>
                                    <Button fullWidth sx={{ marginTop: 1 }} variant="contained" onClick={() => onUpload()}>
                                        Upload
                                    </Button>
                                </Box>
                            </>
                        ) : (
                            <>
                                <Webcam audio={false} height={'auto'} ref={webcamRef} screenshotFormat="image/jpeg" width={'100%'} />
                                <Button fullWidth sx={{ marginTop: 1 }} variant="contained" onClick={capture}>
                                    Capture Photo
                                </Button>
                            </>
                        )}
                    </>
                )}

                {uploadType === 1 && (
                    <>
                        {imageUrl ? (
                            <>
                                <img src={imageUrl} alt="Captured" style={{ width: '100%' }} />
                                <Box display={'flex'} gap={2}>
                                    <Button fullWidth sx={{ marginTop: 1 }} variant="contained" onClick={() => setImageUrl(null)}>
                                        Change Photo
                                    </Button>
                                </Box>
                            </>
                        ) : (
                            <Dropzone onChange={onChangeImage} header={false} accept="image/*" disabled={isUploading} />
                        )}
                    </>
                )}

                {!imageUrl && filesQueue.map((file: any) => (
                    <Box key={file.name}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            {file.name}
                            <IconButton>{file.uploadProgress < 100 ? <Cancel /> : <Check color="success" />}</IconButton>
                        </Box>
                        <LinearProgress variant="determinate" value={file.uploadProgress} />
                    </Box>
                ))}
                <br />
                <Button fullWidth sx={{ marginTop: 1 }} variant="contained" onClick={onSendMileage}>
                    {props.mileageType} Mileage
                </Button>
            </>
        </Box>
    );
}
